/**
 * Drops legacy persisted login helpers (remember-me identifiers/passwords).
 * Also clears stray sessionStorage `login_identifier` from older flows.
 */
export function clearLegacyLoginStorageKeys(): void {
  try {
    localStorage.removeItem('remember_me');
    localStorage.removeItem('login_identifier');
    localStorage.removeItem('login_password');
    sessionStorage.removeItem('login_identifier');
  } catch {
    // ignore quota / privacy mode errors
  }
}
